<template>
   <div class="modal fade " id="rebateModal"
     tabindex="-1" role="dialog"
     aria-labelledby="rebateModalLabel">
      <div class="modal-dialog d-flex h-100" role="document">
        <div class="modal-content my-auto rounded-0 border-dark">
          <div class="px-4 my-3">
              <h4 class="card-title mb-0 text-center text-uppercase peak-sans w-100 pb-1 pt-3" style="border-bottom:2px solid #b10000">
                  {{modalHeader}}
              </h4>
          </div><!--col-->
          <div class="col-11 mx-auto ">
            <RebateCheckComponent v-if="!currentRebate.amount"></RebateCheckComponent>
            <div :class="{'show':currentRebate.amount}" v-else>
              <h4 class="modal-title text-center" id="rebateModalLabel">
                  {{ rebate.customer }}
              </h4>
              <div class="steps d-flex no-gutters w-50 mx-auto justify-content-center mt-4 text-uppercase">
                <div class="relative mb-4 border h-25 pt-1 rounded-pill"><i class="fa fa-check status-icon"></i>
               <label class="absolute text-center text-dark peak-sans" style="left: 3%; bottom: -52%; font-size: 15px;">SUBMITTED</label></div>
                <!-- <div :class="{'active' : rebate.status==1001}" class="relative mb-4 border h-25 pt-1 rounded-pill"><i class="fa status-icon"
                :class="{
                  'fa-hourglass-half wide' : rebate.status==1001,
                  'fa-check': rebate.status !== 1001
                  }"></i>
                  <label class="absolute text-center text-dark peak-sans" style="
                      left: 0%;
                      bottom: -100%;
                      font-size: 13px;
                      line-height:16px;
                  ">UNDER<br>REVIEW</label>
                  </div> -->
                <div class="col-2 mt-2"><hr></div>
                <div v-if="rebate.status== 1001" class="relative mb-4 border h-25 pt-1 rounded-pill bg-light"><i class="fa status-icon"
                :class="{
                  'fa-hourglass-half wide' : rebate.status==1001,
                  'fa-check': rebate.status !== 1001
                  }"></i>
                  <label class="absolute text-center text-dark peak-sans" style="
                        left: -2%;
                        bottom: -60%;
                        font-size: 15px;
                        line-height:16px;
                    ">UNDER REVIEW
                  </label>
                  </div>
                  <!--SPECIAL CASE FOR QUESTIONED ENTRIES -->
                    <div v-else-if="rebate.status > 5000"  class="active relative mb-4 border h-25 pt-1 rounded-pill">
                        <i class="fa fa-check status-icon"></i>
                        <label class="absolute text-center text-dark peak-sans" style="
                                left: 4%;
                                bottom: -47%;
                                font-size: 15px;
                                line-height:16px;
                            ">Pending
                        </label>
                    </div>
                  <!--//SPECIAL CASE FOR QUESTIONED ENTRIES -->
                   <div v-else :class="{'active' : 2000 <= rebate.status <= 3000 }" class="relative mb-4 border h-25 pt-1 rounded-pill"><i class="fa fa-times status-icon" style="padding:39px 29px;"></i>
                  <label class="absolute text-center text-dark peak-sans" style="
                        left: 4%;
                        bottom: -47%;
                        font-size: 15px;
                        line-height:16px;
                    ">{{rebate.status_type}}
                  </label>
                  </div>
                  <div v-else :class="{'active' : rebate.status <= 4000 }" class="relative mb-4 border h-25 pt-1 rounded-pill"><i class="fa fa-check status-icon"></i>
                  <label class="absolute text-center text-dark peak-sans" style="
                        left: 4%;
                        bottom: -47%;
                        font-size: 15px;
                        line-height:16px;
                    ">{{rebate.status_type}}
                  </label>
                  </div>
                   <div class="col-2 mt-2"><hr></div>
                <div :class="{'active' : rebate.status > 4000 && rebate.status < 5000}" class="relative mb-4 border h-25 pt-1 rounded-pill"><i class="fa fa-check status-icon" :class="
                {'text-light':rebate.status < 4000 || rebate.status >= 5000}"></i>
                <label class="absolute left text-center w-100 text-dark peak-sans" style="
                      bottom: -47%;
                      font-size: 15px;
                      line-height:16px;
                  ">SENT</label></div>
              </div>



              <div class="mt-5 mx-2 text-center">
                <p class="" v-if="rebate.status>4000 && rebate.status<5000">Your rebate of ${{ rebate.amount }} was accepted and sent via email on {{ rebate.updated }}.</p>
                <p class="" v-else-if="rebate.status>3000 && rebate.status<4000">Your rebate of ${{ rebate.amount }} was accepted on {{ rebate.updated }} and is currently being processed.</p>
                <p class="" v-else-if="isRejected">Your rebate of ${{ rebate.amount }} was not accepted.  {{rebate.status_text}}<br><br>If you would like to resubmit your rebate claim.  You may do so <a href="#" @click="setUpFormEdit">here</a>.</p>
                <p class="" v-else>Your rebate of ${{ rebate.amount }} submitted on {{ rebate.updated }} is currently being reviewed.</p>
              </div>
              <div class="my-4 mx-4 text-center">
                <p>If you have any questions please see our <a href="/faqs">FAQ</a>.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {mapState} from 'vuex';
    import RebateCheckComponent from './RebateCheckComponent.vue';
    export default {
        mounted(){
         //this.$store.dispatch('getStatuses');
        },
        data() {
            return {
                modalHeader:"CHECK YOUR REBATE STATUS",
                rebate: {
                    id:'',
                    customer: '',
                    confirmation_code: '',
                    status: '',
                    status_text: '',
                    status_type: '',
                    amount: '',
                    created: '',
                    updated: '',
                    sent:''
                },
                newRebate:''
            }
          },
        methods: {
            setData(rebateInfo) {
                this.modalHeader="REBATE STATUS FOR",
                this.rebate.id = this.currentRebate.id;
                this.rebate.confirmation_code = this.currentRebate.confirmation_code;
                this.rebate.amount = this.currentRebate.amount;
                this.rebate.customer = this.currentRebate.sho_customer.first_name + " " + this.currentRebate.sho_customer.last_name;
                this.rebate.status = this.currentRebate.status;
                this.rebate.status_type = this.currentRebate.rebate_status.status_type;
                this.rebate.status_text = this.currentRebate.rebate_status.status_text;
                this.rebate.created = this.moment(this.currentRebate.created_at).format('M/D/YY');
                this.rebate.updated = this.moment(this.currentRebate.updated_at).format('M/D/YY');
            },
            setUpFormEdit(){
                this.$store.commit('SET_SHOWSLIDER')
                this.$nextTick(()=>{
                    this.$store.commit('SET_SLIDERSTEP', 4)
                    $('#rebateModal').modal('hide');
                })
            }
        },
         watch:{
            currentRebate(){
                this.setData(this.currentRebate)
            },

        },
        computed:{
           ...mapState(['currentRebate']),
           isRejected: function(){
            return (3000 > this.currentRebate.status  && this.currentRebate.status > 1999 ? true : false)
          },
        },
        components:{
          RebateCheckComponent,
        }

     }
</script>
<style lang="scss">
  .status-icon{
    font-size: 31px;
    line-height: 0;
    padding:39px 26px;
  }
  .wide{
    padding: 39px 29px !important;
  }
</style>
